import './App.css';
import Router from './Component/Router.js'

function App() {
  return (
    <div>
      <Router/>
    </div>
  );
}

export default App;
